
import { IExport1CDto, IExport1CProcedureCodeDto, IExport1CUpdateProcedureCodeDto, IExport1CUpdateProcedureCodeResponseDto, IExport1CViewDto } from "../../coreapi-dto/service/export1C";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "../dirs/baseDirRequest";

class Export1CRequest extends BaseDirRequest<IExport1CViewDto, IExport1CDto> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "Export1c", token, eventHandler)
    }

    getData(callback?: (e) => void) {
        this.post(`${this._baseUrl}/${this._routePrefix}/GetData`, {}, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            }
        })
    }

    export(body, callback?: (e) => void) {
        this.post(`${this._baseUrl}/${this._routePrefix}/Export`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    exportOperations(body, callback?: (e) => void) {
        this.post(`${this._baseUrl}/${this._routePrefix}/ExportOperations`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    exportContractors(body, callback?: (e) => void) {
        this.post(`${this._baseUrl}/${this._routePrefix}/ExportContractors`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    exportStores(body, callback?: (e) => void) {
        this.post(`${this._baseUrl}/${this._routePrefix}/ExportStores`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getProcedureCode(callback?: (e: CoreApiResponse<IExport1CProcedureCodeDto>) => void) {
        this.get<IExport1CProcedureCodeDto>(`${this._baseUrl}/${this._routePrefix}/GetProcedureCode`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler && e.respType === "isFailed") {
                this._eventHandler.onGetResponse(e);
            }
            callback?.(e);
        })
    }

    updateProcedureCode(body: IExport1CUpdateProcedureCodeDto, callback?: (e: CoreApiResponse<IExport1CUpdateProcedureCodeResponseDto>) => void) {
        this.post<IExport1CUpdateProcedureCodeResponseDto>(`${this._baseUrl}/${this._routePrefix}/UpdateProcedureCode`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e);
            }
            callback?.(e);
        })
    }
}

export default Export1CRequest